export default function () {
  return [
    {
      type: 'DatePicker',
      title: '编号',
      [$field]: 'logYear',
      props: {
        type: 'year'
      },
      rules: []
    },
    {
      type: 'Input',
      title: '子系统',
      [$field]: 'username',
      rules: ['']
    },
    {
      type: 'Input',
      title: '待办名称',
      [$field]: 'userCode',
      rules: ['required']
    },
    {
      type: 'Input',
      title: '待办分组',
      [$field]: 'username',
      rules: ['']
    },
    {
      type: 'Input',
      title: '工号',
      [$field]: 'userCode',
      rules: ['required']
    }
  ]
}